import script from "./choseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./choseCard.vue?vue&type=script&setup=true&lang=js"

import "./choseCard.vue?vue&type=style&index=0&id=576eff1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576eff1c"]])

export default __exports__